import * as PIXI from 'pixi.js';
import EventManager from "./lib/EventManager";
import * as Events from "./Events";
import {Alien} from "./Tiles";
import MorteImage from "../assets/morte.png";

import AlienStand from '../assets/al_stand.png';
import GreenScream from '../assets/al_muove.png';
import GreenWorried from '../assets/al_over.png';
import GreenStop from '../assets/al_endrun.png';

import YellowStand from '../assets/y_stand.png';
import YellowScream from '../assets/y_muove.png';
import YellowWorried from '../assets/y_over.png';
import YellowStop from '../assets/y_endrun.png';

import RedStand from '../assets/r_stand.png';
import RedScream from '../assets/r_muove.png';
import RedWorried from '../assets/r_over.png';
import RedStop from '../assets/r_endrun.png';

import Win from '../assets/win.png'

import {emit, eventSubscriber, on} from "./lib/EventDecorators";
import state from "./State";
import { gsap } from 'gsap';
import { PixiPlugin } from "gsap/PixiPlugin";
import { CustomEase } from "../package/CustomEase";
import { CustomWiggle } from "../package/CustomWiggle";

import { app } from "./initializePixi";
import {GlowFilter} from '@pixi/filter-glow';
import Tween = gsap.core.Tween;

gsap.registerPlugin(PixiPlugin, CustomEase, CustomWiggle)
PixiPlugin.registerPIXI(PIXI)
CustomWiggle.create("funWiggle", {wiggles:5, type:"random"});

const textures = {
  green: {
    stand: PIXI.Texture.from(AlienStand),
    scream: PIXI.Texture.from(GreenScream),
    worried: PIXI.Texture.from(GreenWorried),
    stop: PIXI.Texture.from(GreenStop)
  },
  yellow: {
    stand: PIXI.Texture.from(YellowStand),
    scream: PIXI.Texture.from(YellowScream),
    worried: PIXI.Texture.from(YellowWorried),
    stop: PIXI.Texture.from(YellowStop)
  },
  red: {
    stand: PIXI.Texture.from(RedStand),
    scream: PIXI.Texture.from(RedScream),
    worried: PIXI.Texture.from(RedWorried),
    stop: PIXI.Texture.from(RedStop)
  },
  win: PIXI.Texture.from(Win)
}

const colors = {
  green: 0x5CB564,
  yellow: 0xF4EB64,
  red: 0xE8414B
}

@eventSubscriber
export class AlienSprite extends PIXI.Sprite {

  interactive = true
  id: string
  currentAnimation: gsap.core.Timeline
  cutAnimation: boolean = false
  glowTween: Tween
  isDead: boolean = false

  constructor(options: { id: "green" | "yellow" | "red" }) {
    super()
    this.id = options.id
    this.texture = textures[this.id].stand

    this.on("mousedown", (event) => {
      EventManager.emit(Events.selectAlien, this.id)
    })

    this.on("tap", (event) => {
      EventManager.emit(Events.selectAlien, this.id)
    })

    EventManager.on('orientation-changed', (orientation) => {
      if (orientation === 'portrait') {
        this.angle = 270
        this.pivot.set(38, 12)
      }
      if (orientation === 'landscape') {
        this.angle = 0
        this.pivot.set(6, 12)
      }
    })

    EventManager.on(Events.glowAlien, id => {

      if (this.isDead) {
        if (this.glowTween) this.glowTween.kill()
        this.alpha = 1
        this.filters = []
      } else {
        if (this.id === id) {
          this.filters = [new GlowFilter({ color: colors[id] })]
          this.glowTween = gsap.fromTo(this.filters[0], { outerStrength: 1 }, { outerStrength: 4, duration: 1, yoyo: true, repeat: -1 })
          this.alpha = 0.9
          this.texture = textures[this.id].worried
        } else {
          if (this.glowTween) this.glowTween.kill()
          this.alpha = 1
          this.filters = []
          this.texture = textures[this.id].stand
        }
      }
    })


  }

  updatePosition(alien: Alien) {
    const deltaX = alien.x * 32 - this.x
    const deltaY = alien.y * 32 - this.y
    this.texture = textures[this.id].worried
    this.isDead = alien.isDead
    if (state.currentLevel.completed) EventManager.lock([Events.move, Events.undo])
    if (this.currentAnimation) this.currentAnimation.clear().eventCallback("onComplete", null).kill()
    if (this.cutAnimation) {
      this.scale.y = 1
      this.scale.x = 1
    }
    this.cutAnimation = true
    EventManager.lock([Events.move, Events.undo])
    this.currentAnimation = gsap.timeline({
      onComplete: () => {
        this.cutAnimation = false
        if (alien.isDead) {
          this.texture = PIXI.Texture.from(MorteImage)
          EventManager.emit(Events.glowAlien, this.id)
        } else {
          if (state.currentLevel.completed) {
            this.texture = textures.win
            setTimeout( () => {
              EventManager.emit(Events.nextLevel)
            }, 1000)
          } else {
            this.texture = textures[this.id].stand
          }
        }
      }
    })
      .to(this, {
        x: alien.x * 32,
        y: alien.y * 32,
        duration: 0.3,
        ease: "power2.in",
      })
      .to(this.scale, {
        y: state.orientation === 'portrait' ? 1 + Math.abs(deltaX / 640) : 1 + Math.abs(deltaY / 480),
        x: state.orientation === 'portrait' ? 1 + Math.abs(deltaY / 480) : 1 + Math.abs(deltaX / 640),
        duration: 0.3,
        ease: "wiggle(1)"
      },  "<")
      .to(app.view, {
        y: deltaY / 64,
        x: deltaX / 64,
        duration: 0.2,
        ease: "funWiggle"
      }, ">")
      .set(app.view, {
        y: 0,
        x: 0
      }, "<")

      // .fromTo(this.scale, { y: 0.8 }, { y: 1 })

      //.call(() => {
        //EventManager.unlock([Events.move, Events.undo])
        /* this.texture = textures[this.id].stop */
      //}, null, "<")

      .set(this, {
        texture: alien.isDead ? PIXI.Texture.from(MorteImage) : state.currentLevel.completed ? textures.win : textures[this.id].stop,
        cutAnimation: false
      }, "<")
      .call(() => {
        if (!state.currentLevel.completed) EventManager.unlock([Events.move, Events.undo])
      }, null, ">-0.05")
      .to(this, {duration: 1})

  }

}
